/**
 * Topic categories for objections and FAQs
 * These categories represent the subject/topic of the question,
 * not the source type (Original vs Variation)
 */

export enum TopicCategory {
  AUTHENTICITY = 'authenticity',
  EFFECTIVENESS = 'effectiveness',
  PRICING = 'pricing',
  SAFETY = 'safety',
  IMPLEMENTATION = 'implementation',
  DURABILITY = 'durability',
  GUARANTEE = 'guarantee',
  PRODUCT_CHARACTERISTICS = 'product_characteristics',
  TECHNICAL = 'technical',
  APPLICATION = 'application',
  SKEPTICISM = 'skepticism',
  ENVIRONMENTAL = 'environmental',
  OTHER = 'other'
}

export const TOPIC_CATEGORY_LABELS: Record<TopicCategory, string> = {
  [TopicCategory.AUTHENTICITY]: 'Authenticity',
  [TopicCategory.EFFECTIVENESS]: 'Effectiveness',
  [TopicCategory.PRICING]: 'Pricing',
  [TopicCategory.SAFETY]: 'Safety',
  [TopicCategory.IMPLEMENTATION]: 'Implementation',
  [TopicCategory.DURABILITY]: 'Durability',
  [TopicCategory.GUARANTEE]: 'Guarantee',
  [TopicCategory.PRODUCT_CHARACTERISTICS]: 'Product Characteristics',
  [TopicCategory.TECHNICAL]: 'Technical',
  [TopicCategory.APPLICATION]: 'Application',
  [TopicCategory.SKEPTICISM]: 'Skepticism',
  [TopicCategory.ENVIRONMENTAL]: 'Environmental',
  [TopicCategory.OTHER]: 'Other'
};

export const getTopicCategoryLabel = (category: TopicCategory): string => {
  return TOPIC_CATEGORY_LABELS[category] || 'Other';
};

export const getAllTopicCategories = (): TopicCategory[] => {
  return Object.values(TopicCategory);
};

/**
 * Competitor type categories
 * These categories represent the type of competitor
 */
export enum CompetitorTypeCategory {
  DIRECT_COMPETITOR = 'direct_competitor',
  INDIRECT_COMPETITOR = 'indirect_competitor',
  ALTERNATIVE_SOLUTION = 'alternative_solution'
}

export const COMPETITOR_TYPE_LABELS: Record<CompetitorTypeCategory, string> = {
  [CompetitorTypeCategory.DIRECT_COMPETITOR]: 'Direct Competitor',
  [CompetitorTypeCategory.INDIRECT_COMPETITOR]: 'Indirect Competitor',
  [CompetitorTypeCategory.ALTERNATIVE_SOLUTION]: 'Alternative Solution'
};

export const getCompetitorTypeLabel = (category: string): string => {
  return COMPETITOR_TYPE_LABELS[category as CompetitorTypeCategory] || category;
};